import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background-color: #000;
  color: #FF7C24;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const Title = styled.p`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const StreakOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #fff;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: bold;
  width: 80%;
  max-width: 400px;
  cursor: pointer;
  margin-bottom: 15px;
  color: #fff;
  transition: all 0.3s ease-in-out;
  
  &:hover {
    background-color: #FF7C24;
    color: #000;
  }
`;

const StreakMessage = styled.div`
  border: 2px solid #555;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  color: #2ECC71;
  border-radius: 10px;
  margin-top: 20px;
`;

const CommitButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px;
  padding: 12px 30px;
  width: 80%;
  max-width: 300px;
  margin-top: 30px;
`;

const PostActivationStreakCommitPage = () => {
  const navigate = useNavigate();
  const [selectedStreak, setSelectedStreak] = useState(null);

  const handleStreakSelect = (streak) => {
    setSelectedStreak(streak);
  };

  const handleContinue = () => {
    if (selectedStreak) {
      navigate('/post-activation-streak-commit-reward', { state: { selectedStreak } });
    } else {
      alert("Please select a streak commitment!");
    }
  };

  return (
    <StyledContainer>
      {/* ✅ Title */}
      <Title>Commit to learning Trading and Investing as a lifelong skill</Title>

      {/* ✅ Streak Selection Options */}
      <StreakOption onClick={() => handleStreakSelect("7 day streak")}>
        <span>7 day streak</span> <span>Good</span>
      </StreakOption>

      <StreakOption onClick={() => handleStreakSelect("14 day streak")}>
        <span>14 day streak</span> <span>Great</span>
      </StreakOption>

      <StreakOption onClick={() => handleStreakSelect("30 day streak")}>
        <span>30 day streak</span> <span>Incredible</span>
      </StreakOption>

      <StreakOption onClick={() => handleStreakSelect("50 day streak")}>
        <span>50 day streak</span> <span>Unstoppable</span>
      </StreakOption>

      {/* ✅ Streak Commitment Message */}
      <StreakMessage>Streak goals help you stay committed</StreakMessage>

      {/* ✅ Commit Button */}
      <CommitButton onClick={handleContinue}>I'm committed</CommitButton>
    </StyledContainer>
  );
};

export default PostActivationStreakCommitPage;
